(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("moment"), require("numbro"), require("pikaday"));
	else if(typeof define === 'function' && define.amd)
		define("Handsontable", ["moment", "numbro", "pikaday"], factory);
	else if(typeof exports === 'object')
		exports["Handsontable"] = factory(require("moment"), require("numbro"), require("pikaday"));
	else
		root["Handsontable"] = factory(root["moment"], root["numbro"], root["Pikaday"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_51__, __WEBPACK_EXTERNAL_MODULE_81__, __WEBPACK_EXTERNAL_MODULE_224__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition